if (!customElements.get('og-subscription-benefits')) {
  customElements.define(
    'og-subscription-benefits',
    class OgSubscriptionBenefits extends HTMLElement {
      connectedCallback() {
        this.offer = this.parentElement.querySelector('og-offer');
        if (!this.offer) return;

        // Ordergroove renders the offer template after load, and an og-when whose
        // test fails renders no slot, so CSS cannot reveal its content.
        this.observer = new MutationObserver(() => this.showBenefits());
        this.observer.observe(this.offer, { childList: true, subtree: true });

        this.showBenefits();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      showBenefits() {
        this.offer.querySelectorAll('og-when[test="subscribed"]').forEach((condition) => {
          if (condition.querySelector('.og-benefits')) condition.setAttribute('test', 'subscriptionEligible');
        });
      }
    },
  );
}
